import React, { useState, useEffect, useRef } from "react";
import { GetCurrentUser } from "../../components/GetCurrentUser";
import CaseList from "../CaseList/CaseList";
import { gsap } from "gsap";
import './Cases.scss';
import { useAuth } from "../../context/AuthContext";
import { useCaseSelection } from "../../context/CaseSelectionContext";
import { useBubbleSettings } from "../../context/BubbleSettingsContext";

export const Cases = () => {
  const currentuser = GetCurrentUser();
  const { role } = useAuth()
  const { selectedCaseType, setSelectedCaseType, selectedCourtType, setSelectedCourtType } = useCaseSelection();
  const [previousCaseType, setPreviousCaseType] = useState('fetched');

  const tabsRef = useRef(null);
  const underlineRef = useRef(null);

  const CourtTabsRef = useRef(null);
  const CourtUnderlineRef = useRef(null);

  useEffect(() => {
    const tabs = tabsRef.current;
    const underline = underlineRef.current;
    if (!tabs || !underline) return;

    const activeButton = tabs.querySelector('button.active');
    if (activeButton) {
      const left = activeButton.offsetLeft;
      const width = activeButton.offsetWidth;

      gsap.to(underline, {
        duration: 0.4,
        left: left,
        width: width,
        ease: "power3.out",
      });
    }
  }, [selectedCaseType]);

  useEffect(() => {
    const courttabs = CourtTabsRef.current;
    const courtunderline = CourtUnderlineRef.current;
    if (!courttabs || !courtunderline) return;

    const activeButton = courttabs.querySelector('button.active');
    if (activeButton) {
      const left = activeButton.offsetLeft;
      const width = activeButton.offsetWidth;

      gsap.to(courtunderline, {
        duration: 0.4,
        left: left,
        width: width,
        ease: "power3.out",
      });
    }
  }, [selectedCourtType]);

  useEffect(() => {
    if (selectedCourtType === 'OtherCourt') {
      // Store current case type before switching to Other Court
      setPreviousCaseType(selectedCaseType);
      setSelectedCaseType('added');
    } else {
      // When switching back to High Court or District Court, restore previous case type
      setSelectedCaseType(previousCaseType);
    }
  }, [selectedCourtType]);

  const { bubbleSettings } = useBubbleSettings();
  const highCourtCount = bubbleSettings?.case?.highCourt?.length || 0;
  const districtCourtCount = bubbleSettings?.case?.districtCourt?.length || 0;
  // Fixed: Add otherCourtCount instead of using districtCourtCount
  const otherCourtCount = bubbleSettings?.case?.otherCourt?.length || 0;
  const supremeCourtCount = bubbleSettings?.case?.supremeCourt?.length || 0;

  return (
    <div className="cases-container">
      <div className="cases-tab-main">
        <div className="court-tabs-container">
          <div className="court-tabs" ref={CourtTabsRef}>
            <button
              className={selectedCourtType === 'HighCourt' ? 'active' : ''}
              onClick={() => setSelectedCourtType('HighCourt')}
            >
              High Court {highCourtCount > 0 && <span className="court-badge">{highCourtCount}</span>}
            </button>
            <button
              className={selectedCourtType === 'DistrictCourt' ? 'active' : ''}
              onClick={() => setSelectedCourtType('DistrictCourt')}
            >
              District Court {districtCourtCount > 0 && <span className="court-badge">{districtCourtCount}</span>}
            </button>
            <button
              className={selectedCourtType === 'OtherCourt' ? 'active' : ''}
              onClick={() => setSelectedCourtType('OtherCourt')}
            >
              Other Court
            </button>
            <button
              className={selectedCourtType === 'SupremeCourt' ? 'active' : ''}
              onClick={() => setSelectedCourtType('SupremeCourt')}
            >
              Supreme Court {supremeCourtCount > 0 && <span className="court-badge">{supremeCourtCount}</span>}
            </button>
          </div>
        </div>
        <div className="case-tabs-container">

          {role !== 'customer' && selectedCourtType !== 'OtherCourt' &&
            <div className="case-tabs" ref={tabsRef}>
              <button
                className={selectedCaseType === 'fetched' ? 'active' : ''}
                onClick={() => setSelectedCaseType('fetched')}
              >
                Fetched Cases
              </button>
              <button
                className={selectedCaseType === 'added' ? 'active' : ''}
                onClick={() => setSelectedCaseType('added')}
              >
                Added Cases
              </button>
              {/* <div className="case-underline" ref={underlineRef}></div> */}
            </div>
          }
        </div>
      </div>
      <CaseList username={currentuser} selectedCaseType={selectedCaseType} selectedCourtType={selectedCourtType} />
    </div>
  );
};